import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageMeta from '../../components/common/PageMeta';
import { Button, Row, StatusLabel } from '../../ui/v2';
import IntegrationResult from './IntegrationResult';

const isTruthyParam = (value: string | null) => value?.toLowerCase() === 'true';

export default function PosCallbackSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const connectionStatus = searchParams.get('connection_status');
  const posSystem = searchParams.get('pos_system');
  const alreadyLinked = isTruthyParam(searchParams.get('already_linked'));
  const linkedToCurrentUserParam = searchParams.get('linked_to_current_user');
  const linkedToCurrentUser = isTruthyParam(linkedToCurrentUserParam);
  const linkedToAnotherStore =
    alreadyLinked && linkedToCurrentUserParam?.toLowerCase() === 'false';
  const message = searchParams.get('message');
  const alreadyLinkedMessage =
    message ||
    (linkedToCurrentUser
      ? 'This POSHub connection was already linked to your AskArthur store. No changes were needed.'
      : 'This POSHub connection is already linked to an AskArthur store. No changes were made.');

  return (
    <>
      <PageMeta
        title="Integration Connected | Ask Arthur"
        description="POS integration successful"
      />
      <IntegrationResult
        tone={linkedToAnotherStore ? 'warning' : 'success'}
        title={
          linkedToAnotherStore
            ? 'No changes made – POSHub connection already linked'
            : alreadyLinked
              ? 'Integration already connected'
              : 'Integration connected'
        }
        message={
          alreadyLinked
            ? alreadyLinkedMessage
            : 'Your POS system has been successfully connected to AskArthur.'
        }
        details={
          !linkedToAnotherStore && (connectionStatus || posSystem) ? (
            <>
              {posSystem && <Row label="System">{posSystem}</Row>}
              {connectionStatus && (
                <Row label="Status">
                  <StatusLabel tone="success">
                    {connectionStatus.charAt(0).toUpperCase() +
                      connectionStatus.slice(1)}
                  </StatusLabel>
                </Row>
              )}
            </>
          ) : undefined
        }
        note={
          linkedToAnotherStore
            ? undefined
            : alreadyLinked
              ? 'You can review your POS settings from the Integrations page.'
              : 'AskArthur can now receive and process phone orders through your POS. You can manage this integration from the Integrations page.'
        }
        actions={
          <>
            <Button variant="primary" onClick={() => navigate('/integrations')}>
              Go to Integrations
            </Button>
            <Button onClick={() => navigate('/')}>Back to dashboard</Button>
          </>
        }
      />
    </>
  );
}
